import { selectDoc, selectAll, event } from "../utils/utils";
import $ from "jquery";

export class MiniCart {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.btnsAddToBag = selectAll("[data-mini-cart-add-to-bag]");
    this.elCartModalContainer = selectDoc("[data-cart-modal]");
    this.elQtyModalContainer = selectDoc("[cart-modal-qty]");
    this.elQtyContainer = selectAll("[data-cart-qty]");
    this.cartModalClose = selectDoc("[data-cart-modal-close]");
		this.cartImg = selectDoc(".mini-cart-modal__item img");
		this.cartTitle = selectDoc(".mini-cart-modal__item h5");
  }

  render() {
    this.setAddToBag();
    this.setCartEvents();
  }

  setAddToBag = () => {
    this.btnsAddToBag.forEach((el) => {
      event(el, "click", (e) => {
        const data = {
          id: e.target.dataset.productId,
          quantity: 1,
        };

				// Updating image and text here to avoid minicart showing old images - even if it fails to add to cart
				this.cartImg.src = e.target.dataset.imgSrc;
				this.cartTitle.innerHTML = e.target.dataset.imgTitle;

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: this.displayMiniCart(),
        });
      });
    });
  };

  setCartEvents = () => {
    event(this.cartModalClose, "click", () => {
      this.elCartModalContainer.classList.remove("is-active");
    });
  };

  displayMiniCart = () => {
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/cart.json",
      success: function (cart) {
        this.elCartModalContainer.classList.add("is-active");
        this.elQtyModalContainer.innerHTML = "1";
        this.elQtyContainer.forEach(el => el.innerHTML = cart.item_count + 1);
      }.bind(this),
    });
  };
}
